import React from 'react';
import { ConfigProvider, App } from 'antd';
import { HelmetProvider } from 'react-helmet-async';
import ErrorBoundary from './components/ErrorBoundary';
import NetworkStatus from './components/NetworkStatus';
import AppRoutes from './routing/AppRoutes';
import theme from './theme/theme';
import './index.css';

function MainApp() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <ConfigProvider theme={theme}>
          <App>
            <div className="App">
              {/* Network status indicator */}
              <NetworkStatus />
              
              {/* Main application routes */}
              <AppRoutes />
            </div>
          </App>
        </ConfigProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default MainApp; 